<template>
  <div>
    <b-link v-if="id" class="bg-transparent text-primary border-primary border form-control text-center" :title="$t('queens.delete')" @click.prevent="clickDelete">
      {{ $t('queens.delete') }}
    </b-link>
    <b-modal id="confirm" centered hide-header-close @ok="doDelete">
      <template slot="modal-title">
      {{ $t('queens.confirm_delete.title') }}
      </template>
        {{ $t('queens.confirm_delete.text') }}
      <template slot="modal-footer" slot-scope="{ ok, cancel }">
        <b-button size="lg" class="ml-auto" @click="cancel()">
          {{ $t('queens.confirm_delete.no') }}
        </b-button>
        <b-button size="lg" class="mr-auto" @click="ok()">
          {{ $t('queens.confirm_delete.yes') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'QueenDelete',
  props: ['id', 'colony', 'apiary'],
  methods: {
    clickDelete () {
      this.showModal()
    },
    showModal () {
      this.$bvModal.show('confirm')
    },
    async doDelete () {
      let result
      try {
        const token = await this.$api.user.getToken()
        result = await this.$api.queens.deleteItem({ id: this.id, token })
      } catch (e) {
        if (e.response && e.response.status === 403) {
          this.$router.replace('/login')
        }
        return false
      }
      this.$router.replace('/colony/' + this.colony + '/' + this.apiary)
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  h2 {
    font-size: 1.5rem;
  }
</style>
